export const mapHasLiveStreaming = (league) => {
    league.hasLiveStreaming = (league.tags && league.tags.indexOf("LiveStreaming") >= 0) || false;
};
//# sourceMappingURL=mapHasLiveStreaming.js.map